export default "__VITE_ASSET__hbb0CTsF__"